import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CareAIChat, CareAIChatMessage } from './care-ai-chat.model';

@Injectable({
  providedIn: 'root',
})
export class CareAIService {
  route: string = environment.apiUrl + '/api/CareBot';

  constructor(private _http: HttpClient) {}

  /**
   * Save the chats to local storage
   *
   * @param chats CareAIChat[]
   */
  saveToLocalStorage(chats: CareAIChat[]): void {
    if (typeof window === 'undefined') {
      return;
    }

    localStorage.setItem('chats', JSON.stringify(chats));
  }

  /**
   * Get the chats from local storage
   *
   * @returns CareAIChat[]
   */
  getFromLocalStorage(): CareAIChat[] {
    if (typeof window === 'undefined') {
      return [];
    }

    const chats: string | null = localStorage.getItem('chats');
    return chats ? JSON.parse(chats) : [];
  }

  /**
   * Send a chat to the CareHub API
   *
   * @param chat CareAIChatMessage[]
   * @returns CareAIChatMessage
   */
  sendChat(chat: CareAIChat): Promise<CareAIChatMessage> {
    return firstValueFrom(
      this._http.post<CareAIChatMessage>(this.route, {
        promptHistory: chat.promptHistory,
        searchPreferences: chat.preferences
      })
    );
  }
}
